import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Your logout logic here
    localStorage.removeItem('isAuthenticated');
    navigate('/login');
  };

  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', stiffness: 120 }}
      style={{
        background: 'linear-gradient(135deg, #2c3e50 0%, #4a6baf 100%)',
        color: 'white',
        padding: '1rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 1000
      }}
    >
      {/* Left side - Logo/Title */}
      <motion.div 
        whileHover={{ scale: 1.03 }}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem'
        }}
      >
        <h1 style={{ 
          margin: 0,
          fontSize: '1.5rem',
          fontWeight: '600',
          background: 'linear-gradient(to right, #fff, #ddd)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          School Admin Portal
        </h1>
      
      </motion.div>

      {/* Right side - Navigation buttons */}
      <div style={{ display: 'flex', gap: '1rem' }}>

    


       <motion.button
          whileHover={{ scale: 1.05, boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate('/')}
          style={{
            background: 'rgba(255,255,255,0.1)',
            color: 'white',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '8px',
            padding: '0.5rem 1.25rem',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            transition: 'all 0.3s ease'
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.4 15C19.2669 15.3016 19.227 15.6363 19.2861 15.9606C19.3452 16.2849 19.5003 16.5816 19.7276 16.8089C19.9549 17.0362 20.2516 17.1913 20.5759 17.2504C20.9002 17.3095 21.2349 17.2696 21.5365 17.1365C22.4878 16.726 23.3093 16.0707 23.9166 15.2397C24.5239 14.4087 24.8921 13.4351 24.9806 12.4189C25.0691 11.4027 24.8744 10.3846 24.4201 9.47253C23.9658 8.56046 23.2708 7.79217 22.4142 7.25366C21.5576 6.71515 20.5749 6.42738 19.573 6.42285C18.571 6.41832 17.5859 6.69725 16.7245 7.22803C15.8631 7.75881 15.1607 8.51938 14.6975 9.42499" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4.60005 15C4.73312 15.3016 4.77304 15.6363 4.71393 15.9606C4.65482 16.2849 4.49972 16.5816 4.27241 16.8089C4.0451 17.0362 3.74842 17.1913 3.42411 17.2504C3.09979 17.3095 2.7651 17.2696 2.46355 17.1365C1.51218 16.726 0.690734 16.0707 0.0834188 15.2397C-0.523896 14.4087 -0.892075 13.4351 -0.980558 12.4189C-1.06904 11.4027 -0.874371 10.3846 -0.420082 9.47253C0.0342076 8.56046 0.729234 7.79217 1.5858 7.25366C2.44237 6.71515 3.4251 6.42738 4.42704 6.42285C5.42899 6.41832 6.41408 6.69725 7.27549 7.22803C8.1369 7.75881 8.83929 8.51938 9.30252 9.42499" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
         Activation Plan
        </motion.button>


          <motion.button
          whileHover={{ scale: 1.05, boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate('/purchesplan')}
          style={{
            background: 'rgba(255,255,255,0.1)',
            color: 'white',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '8px',
            padding: '0.5rem 1.25rem',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            transition: 'all 0.3s ease'
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.4 15C19.2669 15.3016 19.227 15.6363 19.2861 15.9606C19.3452 16.2849 19.5003 16.5816 19.7276 16.8089C19.9549 17.0362 20.2516 17.1913 20.5759 17.2504C20.9002 17.3095 21.2349 17.2696 21.5365 17.1365C22.4878 16.726 23.3093 16.0707 23.9166 15.2397C24.5239 14.4087 24.8921 13.4351 24.9806 12.4189C25.0691 11.4027 24.8744 10.3846 24.4201 9.47253C23.9658 8.56046 23.2708 7.79217 22.4142 7.25366C21.5576 6.71515 20.5749 6.42738 19.573 6.42285C18.571 6.41832 17.5859 6.69725 16.7245 7.22803C15.8631 7.75881 15.1607 8.51938 14.6975 9.42499" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4.60005 15C4.73312 15.3016 4.77304 15.6363 4.71393 15.9606C4.65482 16.2849 4.49972 16.5816 4.27241 16.8089C4.0451 17.0362 3.74842 17.1913 3.42411 17.2504C3.09979 17.3095 2.7651 17.2696 2.46355 17.1365C1.51218 16.726 0.690734 16.0707 0.0834188 15.2397C-0.523896 14.4087 -0.892075 13.4351 -0.980558 12.4189C-1.06904 11.4027 -0.874371 10.3846 -0.420082 9.47253C0.0342076 8.56046 0.729234 7.79217 1.5858 7.25366C2.44237 6.71515 3.4251 6.42738 4.42704 6.42285C5.42899 6.41832 6.41408 6.69725 7.27549 7.22803C8.1369 7.75881 8.83929 8.51938 9.30252 9.42499" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
         Subscription Plan
        </motion.button>


        <motion.button
          whileHover={{ scale: 1.05, boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate('/manage-access')}
          style={{
            background: 'rgba(255,255,255,0.1)',
            color: 'white',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '8px',
            padding: '0.5rem 1.25rem',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            transition: 'all 0.3s ease'
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.4 15C19.2669 15.3016 19.227 15.6363 19.2861 15.9606C19.3452 16.2849 19.5003 16.5816 19.7276 16.8089C19.9549 17.0362 20.2516 17.1913 20.5759 17.2504C20.9002 17.3095 21.2349 17.2696 21.5365 17.1365C22.4878 16.726 23.3093 16.0707 23.9166 15.2397C24.5239 14.4087 24.8921 13.4351 24.9806 12.4189C25.0691 11.4027 24.8744 10.3846 24.4201 9.47253C23.9658 8.56046 23.2708 7.79217 22.4142 7.25366C21.5576 6.71515 20.5749 6.42738 19.573 6.42285C18.571 6.41832 17.5859 6.69725 16.7245 7.22803C15.8631 7.75881 15.1607 8.51938 14.6975 9.42499" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M4.60005 15C4.73312 15.3016 4.77304 15.6363 4.71393 15.9606C4.65482 16.2849 4.49972 16.5816 4.27241 16.8089C4.0451 17.0362 3.74842 17.1913 3.42411 17.2504C3.09979 17.3095 2.7651 17.2696 2.46355 17.1365C1.51218 16.726 0.690734 16.0707 0.0834188 15.2397C-0.523896 14.4087 -0.892075 13.4351 -0.980558 12.4189C-1.06904 11.4027 -0.874371 10.3846 -0.420082 9.47253C0.0342076 8.56046 0.729234 7.79217 1.5858 7.25366C2.44237 6.71515 3.4251 6.42738 4.42704 6.42285C5.42899 6.41832 6.41408 6.69725 7.27549 7.22803C8.1369 7.75881 8.83929 8.51938 9.30252 9.42499" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Access Management
        </motion.button>

        <motion.button
          whileHover={{ scale: 1.05, boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}
          whileTap={{ scale: 0.95 }}
          onClick={handleLogout}
          style={{
            background: 'rgba(255,255,255,0.1)',
            color: 'white',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '8px',
            padding: '0.5rem 1.25rem',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            transition: 'all 0.3s ease'
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Logout
        </motion.button>
      </div>
    </motion.header>
  );
}

export default Header;